/**
 * Native console logger that preserves clickable source links
 * Completely bypasses Consola to avoid stack trace issues
 */



// Create transparent loggers using direct console.bind to preserve call stack
function createTransparentLogger(tag: string) {
  const isDev = import.meta.env.DEV
  
  // Use console.bind directly to preserve original call stack
  return {
    trace: isDev ? console.trace.bind(console, `[${tag}]`) : () => {},
    debug: isDev ? console.debug.bind(console, `[${tag}]`) : () => {},
    log: console.log.bind(console, `[${tag}]`),
    info: console.info.bind(console, `[${tag}]`),
    warn: console.warn.bind(console, `[${tag}]`),
    error: console.error.bind(console, `[${tag}]`),
    
    // Simple methods without styling to preserve call stack
    success: console.info.bind(console, `[${tag}] SUCCESS`),
    fail: console.error.bind(console, `[${tag}] FAIL`),
    ready: console.info.bind(console, `[${tag}] READY`),
    start: console.info.bind(console, `[${tag}] START`),
    
    // Development-only detailed logging
    verbose: isDev ? console.log.bind(console, `[${tag}] VERBOSE`) : () => {},
  }
}

export const logger = createTransparentLogger('app')

// Create specialized loggers for different services
export const hueLogger = createTransparentLogger('hue')
export const supabaseLogger = createTransparentLogger('supabase')
export const storageLogger = createTransparentLogger('storage')
export const realtimeLogger = createTransparentLogger('realtime')
export const leaderLogger = createTransparentLogger('leader')
export const apiLogger = createTransparentLogger('api')

// Optional: Console.trace for complex debugging when you need full stack traces
export function traceLog(tag: string, message: string, ...args: any[]) {
  if (!import.meta.env.DEV) return
  console.groupCollapsed(`[${tag}] TRACE ${message}`)
  console.log(...args)
  console.trace('Stack trace:')
  console.groupEnd()
}

export default logger
